export default "__VITE_PUBLIC_ASSET__ecc8bc05__"